import { Link } from "react-router-dom";
import classNames from "classnames";
import { Stack, Typography } from "components";
import styles from "./Tabs.module.css";

const Tab = ({ active, label, onClick }) => (
  <Link
    to={`/appointments?status=${label}`}
    className={classNames(styles.tab, active && styles.active)}
    replace={true}
  >
    <Typography size={-1} weight={500} onClick={onClick}>
      {label}
    </Typography>
  </Link>
);

const Tabs = ({ active, tabs }) => (
  <Stack gap={0}>
    {tabs.map((tab) => (
      <Tab key={tab} label={tab} active={tab === active} />
    ))}
  </Stack>
);

export { Tabs };
